__turbopack_context__.v({
  "meter": "_3yFseW_meter",
  "meter__allocationEstimate": "_3yFseW_meter__allocationEstimate",
  "meter__allocationFill": "_3yFseW_meter__allocationFill",
  "meter__allocationOverage": "_3yFseW_meter__allocationOverage",
  "meter__allocationTick": "_3yFseW_meter__allocationTick",
  "meter__allocationTrack": "_3yFseW_meter__allocationTrack",
  "meter__label": "_3yFseW_meter__label",
  "meter__tooltipTarget": "_3yFseW_meter__tooltipTarget",
});
